module.exports = __webpack_public_path__ + "images/modeling-framework.pdf?v=603efdd7c909f39d33cde3e95b40aeb0";